import React from "react";
import {
  Row,
  Label,
} from "reactstrap";

export default function ActionDetailCard({
  action,
  eventSchedules,
  guestGroups,
  getTypeText,
  renderCommandButtons,
  openEditAction,
  openCopyAction,
  openDialogDeleteAction,
  setModalLogControl,
}) {
  const getScheduleText = React.useCallback(() => {
    let _schedule = eventSchedules.find(s => { return s.id.toString() === action.scheduleId.toString() });
    if (_schedule) {
      return `${_schedule.id} ${_schedule.text}`;
    }
    return '';
  }, [eventSchedules, action]);

  const getGroupText = React.useCallback(() => {
    if (action.groupId.toString() === '' || action.groupId.toString() === '0' || action.groupId === 0) {
      return `Todos`;
    }
    if (action.groupId.toString() === '1' || action.groupId === 1) {
      return `Apenas participantes sem grupo`;
    }

    let _group = guestGroups.find(s => { return s.value === action.groupId.toString() });
    if (_group) {
      return `${_group.value} ${_group.text}`;
    }
    return '';
  }, [action, guestGroups]);

  return (
    <Row style={{ padding: 2, justifyContent: 'center' }}>
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: 5,
          padding: 5,
          boxShadow: '0px 0px 2px #3b3a3a',
          shadowOpacity: 0.25,
          shadowRadius: 3.84,
          elevation: 5,
          justifyContent: "center",
          backgroundColor: '#f5f5f5',
        }}
      >
        <div style={{ paddingBottom: 5, flexDirection: 'row', display: 'flex' }}>
          {renderIcon()}
          <Label htmlFor="formFile" className="form-label">
            {getTypeText(action.type)}
          </Label>
        </div>
        <div style={{ paddingBottom: 5, flexDirection: 'row', display: 'flex', justifyContent: 'space-between' }}>
          {action.description && (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <spam style={{ fontWeight: 'bold' }}>
                Descrição
              </spam>
              <spam>
                {action.description}
              </spam>
            </div>
          )}
        </div>
        {action.type === 'whatsapp' && renderWhatsappDetails()}
        {action.type === 'whatsappOrganizer' && renderWhatsappOrganizerDetails()}
        {renderCommandButtons()}
      </div>
    </Row>
  )

  function renderIcon() {
    if (action.type === 'whatsapp') {
      return (
        <i className="mdi mdi-whatsapp" style={{ paddingRight: 15, fontSize: 20, color: 'green' }} />
      )
    }
    if (action.type === 'whatsappOrganizer') {
      return (
        <i className="mdi mdi-account-group-outline" style={{ paddingRight: 15, fontSize: 20, color: '#456091' }} />
      )
    }
    return null;
  }

  function renderWhatsappDetails() {
    return (
      <>
        <div style={{ paddingBottom: 5, flexDirection: 'row', display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ flexDirection: 'column', display: 'flex', width: '50%' }}>
            <spam style={{ fontWeight: 'bold' }}>
              ID
            </spam>
            <spam>
              {action.id}
            </spam>
          </div>
          <div style={{ flexDirection: 'column', display: 'flex', width: '50%', alignItems: 'flex-end' }}>
            <spam style={{ fontWeight: 'bold' }}>
              Template
            </spam>
            <spam>
              {action.templateId}
            </spam>
          </div>
        </div>
        <div style={{ paddingBottom: 5, flexDirection: 'row', display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ flexDirection: 'column', display: 'flex', width: '50%' }}>
            <spam style={{ fontWeight: 'bold' }}>
              Programação
            </spam>
            <spam>
              {getScheduleText(action)}
            </spam>
          </div>
          <div style={{ flexDirection: 'column', display: 'flex', width: '50%', alignItems: 'flex-end' }}>
            <spam style={{ fontWeight: 'bold' }}>
              Grupo
            </spam>
            <spam>
              {getGroupText(action)}
            </spam>
          </div>
        </div>
        <div style={{ paddingBottom: 5, flexDirection: 'row', display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ flexDirection: 'column', display: 'flex', width: '50%' }}>
            <spam style={{ fontWeight: 'bold' }}>
              Número Servidor
            </spam>
            <spam>
              {action.serverNumber}
            </spam>
          </div>
        </div>
      </>
    )
  }

  function renderWhatsappOrganizerDetails() {
    return (
      <>
        <div style={{ paddingBottom: 5, flexDirection: 'row', display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ flexDirection: 'column', display: 'flex', width: '50%' }}>
            <spam style={{ fontWeight: 'bold' }}>
              ID
            </spam>
            <spam>
              {action.id}
            </spam>
          </div>
          <div style={{ flexDirection: 'column', display: 'flex', width: '50%', alignItems: 'flex-end' }}>
            <spam style={{ fontWeight: 'bold' }}>
              Telefone Organizador
            </spam>
            <spam>
              {action.organizerCellPhone}
            </spam>
          </div>
        </div>
        <div style={{ paddingBottom: 5, flexDirection: 'row', display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ flexDirection: 'column', display: 'flex', width: '50%' }}>
            <spam style={{ fontWeight: 'bold' }}>
              Programação
            </spam>
            <spam>
              {getScheduleText(action)}
            </spam>
          </div>
          <div style={{ flexDirection: 'column', display: 'flex', width: '50%', alignItems: 'flex-end' }}>
            <spam style={{ fontWeight: 'bold' }}>
              Grupo
            </spam>
            <spam>
              {getGroupText(action)}
            </spam>
          </div>
        </div>
        <div style={{ paddingBottom: 5, flexDirection: 'row', display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ flexDirection: 'column', display: 'flex', width: '50%' }}>
            <spam style={{ fontWeight: 'bold' }}>
              Número Servidor
            </spam>
            <spam>
              {action.serverNumber}
            </spam>
          </div>
        </div >
      </>
    )
  }

  function renderCommandButtons() {
    if (
      !openEditAction ||
      !openCopyAction ||
      !openDialogDeleteAction ||
      !setModalLogControl
    ) {
      return null;
    }
    return (
      <div style={{ paddingBottom: 5, flexDirection: 'row', display: 'flex', justifyContent: 'flex-end' }}>
        <i className="mdi mdi-file-edit" style={{ paddingRight: 15, fontSize: 20, cursor: 'pointer', color: '#456091' }} onClick={() => openEditAction(action)} />
        <i className="mdi mdi-content-copy" style={{ paddingRight: 15, fontSize: 20, cursor: 'pointer', color: '#456091' }} onClick={() => openCopyAction(action)} />
        <i className="mdi mdi-delete-outline" style={{ paddingRight: 15, fontSize: 20, cursor: 'pointer', color: 'red' }} onClick={() => openDialogDeleteAction(action)} />
        <i className="mdi mdi-information" style={{ paddingRight: 15, fontSize: 20, cursor: 'pointer', color: 'black' }} onClick={() => setModalLogControl({ open: true, action: action })} />
      </div>
    )
  }
}
